// extracted by mini-css-extract-plugin
module.exports = {"container":"icons_container__lu5IG","icon":"icons_icon__2T5KL"};